export default "__VITE_ASSET__ZLAhcLrn__"